import { NgModule } from '@angular/core';
import { FacetService, ProductFacetService } from '@spartacus/storefront';
import { CatalogEffectsModule } from './effects/catalog-effects.module';
import { CatalogResolversModule } from './resolvers/resolvers.module';
import { CustomFacetService, CustomProductFacetService } from './services';

@NgModule({
  imports: [CatalogResolversModule, CatalogEffectsModule],
  providers: [
    { provide: FacetService, useExisting: CustomFacetService },
    { provide: ProductFacetService, useExisting: CustomProductFacetService },
  ],
})
export class CatalogFeatureModule {}
